export const quickPayBanks = [
    {
        code: "MBB",
        name: "Maybank"
    },
    {
        code: "CIMB",
        name: "CIMB"
    },
    {
        code: "HLB",
        name: "Hong Leong Bank"
    },
    {
        code: "PBB",
        name: "Public Bank"
    },
    {
        code: "RHB",
        name: "RHB"
    },
    {
        code: "AMB",
        name: "AmBank"
    },
    {
        code: "ABB",
        name: "Affin Bank"
    },
    {
        code: "BSN",
        name: "Bank Simpanan Nasional"
    },
    {
        code: "ALB",
        name: "Alliance Bank"
    },
    // {
    //     code: "AGRO",
    //     name: "Agro Bank"
    // },
    // {
    //     code: "BIMB",
    //     name: "Bank Islam"
    // },
    // {
    //     code: "BKRM",
    //     name: "Bank Rakyat"
    // },
    // {
    //     code: "BMMB",
    //     name: "Bank Mualamat"
    // },
    // {
    //     code: "BOCM",
    //     name: "Bank of China"
    // },
    // {
    //     code: "HSBC",
    //     name: "HSBC"
    // },
    // {
    //     code: "KFH",
    //     name: "KFH"
    // },
    // {
    //     code: "OCBC",
    //     name: "OCBC Bank"
    // },
    // {
    //     code: "SCB",
    //     name: "Standard Chartered"
    // },
    // {
    //     code: "UOB",
    //     name: "United Overseas Bank"
    // }
]